export default function truncateAddress(
  address: string,
  headChars = 4,
  tailChars = 4
) {
  if (!address) {
    return '';
  }

  return `${address.substring(0, headChars)}...${address.slice(-tailChars)}`;
}
